import { isAxiosError } from 'axios';
import type { TFunction } from 'i18next';
import { z } from 'zod';

const validationErrorSchema = z.object({
  errors: z.record(z.string(), z.array(z.string())),
});
const supplierLeadTimeMessage =
  /^Supplier (.+): (production|delivery) lead time must be greater than zero weeks\.$/;

export function getSupplierLeadTimeError(error: unknown, t: TFunction) {
  if (!isAxiosError(error) || error.response?.status !== 422) {
    return;
  }
  const parsed = validationErrorSchema.safeParse(error.response.data);
  if (!parsed.success) {
    return;
  }
  const messages: string[] = [];
  for (const field of ['production', 'delivery']) {
    for (const message of parsed.data.errors[`supplierLeadTimes.${field}`] ??
      []) {
      const match = message.match(supplierLeadTimeMessage);
      if (match) {
        messages.push(
          t('supplierLeadTimeError', {
            ns: 'lotSizing',
            supplier: match[1],
            field: t(`supplierLeadTimeFields.${match[2]}`, { ns: 'lotSizing' }),
          }),
        );
      }
    }
  }
  return messages.length ? messages.join(' ') : undefined;
}
